module.exports = __webpack_public_path__ + "fonts/fs_lola-bold-webfont.b64007f0.ttf";